/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setStoryProperty } from 'state/actions/embedsState/embedManagementState/content_status';
// component
import StoryTitle from 'material/embeds/content/shared/storytitle/storytitle';



/* ========== ~~~~~~~~~~ EMBED : STORY TITLE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    embedLocationType: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
    contentTitle: embedsState.embedManagementState.contentStatus.contents[contentId]['story']['title'],
    isValid: embedsState.embedManagementState.contentStatus.contents[contentId]['story']['isTitleValid']
});


const mapDispatchToProps = dispatch => ({
    setStoryProperty: (contentId, property, value) => dispatch(setStoryProperty(contentId, property, value))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StoryTitle);
